/**
 * Global Variables
 */
var bundleOptions = []
window.bundleOptions = bundleOptions
let variantSelectIndex = 0
let formData = {}
let bundlePriceArray = []
let bundleCamparePriceArray = []

const $cartNotification = document.querySelector('cart-notification')
const bundle_discount_value = document.querySelector('.bundle-discount-value')
const $price = document.querySelector('.bundle-price')
const $btn_price = document.querySelector('.btn_price')

const $productBundleContainers = document.querySelectorAll('.product-bundle-container')

const $bundleTitle = document.querySelector('h1.bundle-title').textContent
const $bundleDiscountValue = document.querySelector('.bundle-discount-value')?.textContent
const $originalPrice = document.querySelector('.original-price')

// const $errorMessage = document.querySelector('')

class ErrorMessage extends HTMLElement {
  constructor() {
    super()
  } 

  show() {
    this.classList.replace('hidden', 'block')
    this.scrollIntoView({ behavior: 'smooth' })
  }

  renderErrorMessage(message) {
    this.querySelector('p').textContent = message
  }
}

customElements.define('error-message', ErrorMessage)

$productBundleContainers.forEach((element) => {
  element.addEventListener('click', (event) => {
    if (
      event.target === element ||
      event.target.classList.contains('product-bundle-container-title') ||
      event.target === element.querySelector('h3')
    ) {
      $('.product-bundle-container').removeClass('open',"slow");
      $('.product-bundle-container').find('variant-selects-bundle').slideUp();
      $(element).find('variant-selects-bundle').slideDown();
      element.classList.add('open')
      console.log(element);
      // event.target.classList.toggle('open')
      // element.scrollIntoView({ behavior: 'smooth' })
    }
  })
})

/**
 * VariantSelectsBundle
 *
 * This class is extending the VariantSelects and overwriting
 * the onVariantChange() from the parent class
 */
class VariantSelectsBundle extends VariantSelects {
  constructor() {
    super()

    this.currentIndex = variantSelectIndex++
    this.variants = super.getVariantData()
    this.optionContainers = this.querySelectorAll('.options')
    this.currentSize = this.getFirstAvailableVariant().option1

    // Set default variant
    bundleOptions[this.currentIndex] = this.getFirstAvailableVariant()

    /**
     * Option Containers
     *
     * Index 0: Size
     * Index 1: Colour
     * Index 2: Null
     *
     */
    this.optionContainers.forEach((container, index, array) => {
      const buttons = container.querySelectorAll('button')

      this.disableButtons(index, array)

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const label = button.querySelector('span').textContent
          
          // If Index 0 in Option Container (Sizes), set current size
          if (index === 0) this.currentSize = label
          if (index === 1) this.currentcolor = label
          var currentSize = this.currentSize;
          var currentColor = this.currentcolor;

          /* get attr color */

          //var attr_selected_color = $(this).attr('attr_selected_color');
          
          var current_index = $(button).parents(".product-bundle-container").index();
          
          if(current_index == 2 ){
            // $(".product-bundle-container").find('button span').text(this.currentSize).trigger("click");
           // $(".product-bundle-container").find('button[title="Cloud Grey"]').trigger("click");
            
            var button_text = $(".product-bundle-container").find('button').children('span').each(function(){
              
            var cur_text = $(this).text();

              if(cur_text == currentSize){
                // $(this).parents("button").trigger("click");
              } 
              if(cur_text == currentColor){
                // $(this).parents("button").trigger("click");
              }
            });

          }
          // var button_text = $(".product-bundle-container").find('button').children('span');
          // console.log("current_index=>",current_index);
          console.log("this.currentSize=>",this.currentSize);
          console.log("this.currentcolor=>",this.currentcolor);
        var var_div = $(button).parents(".product-bundle-container").find(".next_btn").addClass('show');
          if(this.currentSize != undefined && this.currentSize !="" && this.currentcolor != undefined && this.currentcolor !="" ){
            var var_div = $(button).parents(".product-bundle-container").find(".next_btn").removeClass('disabled');            
          }
          if(this.currentcolor){
            var currentColorr = this.currentcolor.replace("-"," ").toLowerCase();
            $(".product__media-list .swatch_"+currentColorr).trigger('click');
          }
        $(button).parents(".product-bundle-container").find(".load_variant_0").text(this.currentSize);
        $(button).parents(".product-bundle-container").find(".load_variant_1").text(this.currentcolor);
          this.disableButtons(index, array)

          buttons.forEach((element) => {
            element.classList.remove('selected')
            // if (!element.dataset.type) return
            // const $iconQuestion = element.querySelector('.icon-question')
            // $iconQuestion.classList.remove('opacity-0')
          })

          button.classList.add('selected')
          // if (button.dataset.type) button.querySelector('.icon-question').classList.add('opacity-100')

          const $select = button.parentElement.closest('.select').querySelector('select')
          const $options = Array.from($select.options)

          const optionToSelect = $options.find((item) => {
            return item.value === label
          })
          optionToSelect.selected = true

          const changeEvent = new Event('change')
          this.dispatchEvent(changeEvent)
        })
      })
    })

    this.updateFormData()
    this.updatePrice()
  }

  /**
   * Disables Variant Buttons which are not available based on the Current Size
   *
   * @param {integer} index - The current index of the Options Container
   * @param {array} array - The Options Container Array
   */
  disableButtons(index = 0, array = []) {
    if (!array.length) return

    const relatedVariants = this.variants.filter((variant) => variant.option1 === this.currentSize)
    const unAvailableVariants = relatedVariants.filter((variant) => !variant.available)

    array[index + 1]?.querySelectorAll('button').forEach((button) => {
      button.classList.remove('disabled')
      button.disabled = false
      unAvailableVariants.forEach((item) => {
        if (button.querySelector('span').textContent === item.option2) {
          button.classList.add('disabled')
          button.disabled = true
        }
      })
    })
  }

  getFirstAvailableVariant() {
    return this.variants.find((variant) => variant.available)
  }

  onVariantChange() {
    super.updateOptions()
    super.updateMasterId()
    bundleOptions[this.currentIndex] = this.currentVariant
    this.updateFormData()
    this.updatePrice()
  }

  updatePrice() {
    // console.log('updatePrice()')
    bundleOptions.forEach((items,index) => {
      var qty = $(".product-bundle-container").eq(index).find(".quantity__input").val();
      var prices = (items.price) * (qty);
      bundlePriceArray.push(prices)
      console.log("itemsqty=>",qty,index);
      var prices2 = (items.compare_at_price) * (qty);
      bundleCamparePriceArray.push(prices2)
    })

    
    const total = bundlePriceArray.reduce((previousValue, currentValue) => previousValue + currentValue, 0) / 100
    const c_total = bundleCamparePriceArray.reduce((p, c) => p + c, 0) / 100
    
    const currencySymbol = Shopify.currency.active === 'GBP' ? '£' : '€'
     console.log("total=>",bundlePriceArray);
    console.log("bundleDiscountValue=>",bundle_discount_value.dataset.bundleDiscount);
    
    if(bundle_discount_value.dataset.bundlePercentage =="true"){
      if(bundle_discount_value.dataset.bundleDiscountValue !=""){
        var bu_discount = (total) - (total) * (bundle_discount_value.dataset.bundleDiscount) / (100);      
        var discount_value = (total) * (bundle_discount_value.dataset.bundleDiscount) / (100);      
      }else{
        var bu_discount = total;            
      }      
    }else{
      if(bundle_discount_value.dataset.bundleDiscountValue !=""){
        var bu_discount = (total) - (bundle_discount_value.dataset.bundleDiscount);      
        var discount_value = (bundle_discount_value.dataset.bundleDiscount);      
      }else{
        var bu_discount = total;            
      }
    }
    // if(discount_value !=""){
    //   const $bundle_save = document.querySelector('.bundle_save').textContent = `${currencySymbol}${parseFloat(discount_value).toLocaleString()}`;      
    // }
    $price.textContent = `${currencySymbol}${parseFloat(bu_discount).toFixed(2).toLocaleString()}`
    $btn_price.textContent = `(${currencySymbol}${parseFloat(bu_discount).toFixed(2).toLocaleString()})`
    // $originalPrice.textContent = `Was from ${currencySymbol}${parseFloat(
    //   total / ($bundleDiscountValue / 100)
    // ).toLocaleString()}`
    if(c_total > 0){
    $originalPrice.textContent = `Was ${currencySymbol}${parseFloat(c_total).toFixed(2).toLocaleString()}`
    }
    bundlePriceArray = []
    bundleCamparePriceArray = []
  }

  updateFormData() {
    // console.warn('updateFormData()')
    console.log("bundleOptions=>",bundleOptions);
    formData = {
      items: bundleOptions.map(({ id },index) => {
        // console.log("thiisindex",id);
        // console.log("thiisindex2",index);
        var qty = $(".product-bundle-container").eq(index).find(".quantity__input").val();
        console.log("qty=>",qty);
        return {
          id,
          quantity: qty,
          properties: {
            _isBundle: true,
            _bundleTitle: $bundleTitle,
          },
        }
      }),
    }
    console.log("formData.sections=>",formData);
    formData.sections = $cartNotification.getSectionsToRender().map((section) => section.id)
    // formData.sections_url = window.location.pathname
  }
}

customElements.define('variant-selects-bundle', VariantSelectsBundle)

const $buyBundleButton = document.querySelector('#buy-bundle-button')

$buyBundleButton.addEventListener('click', () => {
  fetch(`${routes.cart_add_url}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/javascript',
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((response) => {
      console.log(response)

       freegift_item() 
      
      const { status, description } = response

      const $errorMessage = document.querySelector('error-message')

      // If Error
      if (status === 422) {
        $errorMessage.renderErrorMessage(description)
        $errorMessage.show()
      }

      const obj = {
        items: response.items,
        sections: response.sections,
      }
      $cartNotification.renderContents(obj)
    })
    .catch((error) => {
      console.error('Error:', error)
    })
})
